<template>
  <div>
    <div class="course-room-container">
      <div class="item-list__item-wrapper transparent">
        <div class="item-list__item item-list__item--active item-list-active-recordings">
          <div class="page-controls__action-row" v-if="user_roles.indexOf('ROLE_ADMIN') != -1">
            <button class="page-controls__primary-action button primary" v-b-toggle.sidebar-no-header="'sidebar-new'">
              <span>{{ $t("sessions.create") }}</span>
            </button>
            <button class="page-controls__primary-action button secondary" v-b-toggle.sidebar-no-header="'sidebar-reuse'">
              <span>{{ $t("sessions.reuse") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Sidebar></Sidebar>
    <main id="main-content">
      <div class="body-content recordings-container">
        <div class="page-controls">
          <div class="page-controls__control-row">
            <div class="page-controls__search ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty recordings-search border-search"
                 v-bind:class="{'page-controls__search--opened': search_show }">
              <div class="dropdown-search recordings-search"
                   v-bind:class="{'dropdown-filter--range-active': selected_filter===$t('recordings.interval') }"
              >
                <button class="dropdown-search__toggle icon-button align-right " id="tooltip-target-search-recordings"
                        v-bind:class="{'d-none': search_show}"
                        @click="showSearch()">
                  <i class="isax isax-search-normal-1" />
                </button>
                <b-tooltip target="tooltip-target-search-recordings" triggers="hover">
                  {{ $t("recordings.searchrecordings") }}
                </b-tooltip>
                <div class="dropdown-search__dropdown"
                     v-bind:class="{'d-none': !search_show}">
                  <i class="isax isax-search-normal-1" />
                  <input class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched" type="text"
                         v-bind:placeholder="$t('recordings.searchbyname')"
                         v-model="filter_name">
                  <div class="dropdown-search__controls">
                    <button class="button clear short dropdown-search__control ng-scope d-flex aling-items-center"
                            @click="hideSearch()">
                      <i class="isax isax-close-circle"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="page-controls__filter recordings-search border-search">
              <div
                class="dropdown-filter select-wrapper"
                v-bind:class="{'dropdown-filter--range-active': selected_filter===$t('recordings.interval') }"
              >
                <i class="isax isax-filter" />
                <span class="dropdown-filter__select-label label-filter-by-recordings">{{ $t("sessions.filterby") }}</span>
                <b-dropdown id="dropdown-right" right :text="selected_filter" variant=" dropdown-filter__select button button-select dropdown">
                  <b-dropdown-item @click="recentRecordings()">{{ $t("recordings.recent") }}</b-dropdown-item>
                  <b-dropdown-item @click="recordingIntervals(); selected_filter=$t('recordings.interval')">{{ $t("recordings.interval") }}</b-dropdown-item>
                </b-dropdown>
                <form
                  class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
                  v-if="selected_filter===$t('recordings.interval')"
                >
                  <div class="picker-input date">
                    <p>{{ $t("recordings.datefrom") }}</p>
                    <b-form-datepicker
                      id="start-date" type="text"
                      v-model="filter_start_date"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="es"
                      @input="getUserGroupsClassroomsRecordings()">
                    </b-form-datepicker>
                  </div>
                  <div class="picker-input date">
                    <p>{{ $t("recordings.dateto") }}</p>
                    <b-form-datepicker
                      id="end-date" type="text"
                      v-model="filter_end_date"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="es"
                      @input="getUserGroupsClassroomsRecordings()">
                    </b-form-datepicker>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="full-width-content--small">
          <div v-if="!recordings.length" class="no-content no-results">
              <span class="image pb-3">
                <img class="site-logo" src="/static/img/miroodles_sticker.png">
              </span>
            <span class="no-content-title">{{ $t("recordings.notfound") }}</span>
            <span class="no-content-title font-weight-bold">{{ $t("recordings.notfound2") }}</span>
          </div>
          <table class="content-table" v-if="recordings.length">
            <tbody>
              <tr class="content-table__header content-table__header--shadow">
                <th class="medium-8">{{ $t("recordings.session") }}</th>
                <th class="medium-4">{{ $t("recordings.date") }}</th>
                <th class="medium-4">{{ $t("recordings.duration") }}</th>
                <th class="medium-4" v-if="has_visualization">{{ $t("recordings.visualization") }}</th>
                <th class="medium-4">{{ $t("recordings.download") }}</th>
                <th v-if="['ROLE_ADMIN', 'ROLE_PRESENTER', 'ROLE_EVALUATOR'].some(i => user_roles.includes(i))"></th>
              </tr>
              <tr v-for="recording in recordings" v-bind:key="recording.id" v-if="recordings.length && !recording.expired" class="element-list-row">
                <td>
                  <button class="recording-play-button button--text d-flex align-items-center" @click="launchClickUrl('_blank', recording)">
                    <i class="isax isax-play-circle" v-if="!recording.loadingLaunchUrl || recording.launchUrl"></i>
                    <loading-icon class="svg-icon small default rotate" :size="24" v-if="recording.loadingLaunchUrl"/>
                    <span class="name" v-if="recording.targetSystem == 'COLLAB'">
                      <bdi>{{ recording.sessionName }}/{{ recording.mediaName }}</bdi>
                    </span>
                      <span class="name" v-if="recording.targetSystem != 'COLLAB'">
                      <bdi>{{ recording.name }}</bdi>
                    </span>
                  </button>
                  <EventsReportSidebar
                    :recording="recording"
                    icon-color="#ccc">
                  </EventsReportSidebar>
                </td>
                <td class="date">
                  <span class="inline-column-title">{{ $t("recordings.duration") }}:</span>
                  <bdi>{{ recording.endTime | moment("DD/MM/YYYY") }}</bdi>
                </td>
                <td class="duration">
                  <span class="inline-column-title">{{ $t("recordings.date") }}:</span>
                  <bdi>{{ msToTimeRecordings(recording.duration) }}</bdi>
                </td>
                <td class="visualization" v-if="has_visualization">
                  <span class="inline-column-title" v-if="recording.targetSystem === 'COLLABSECONDARY'">{{ $t("recordings.visualization") }}:</span>
                  <div class="custom-control custom-switch b-custom-control-lg d-inline-flex d-md-block" v-if="recording.targetSystem === 'COLLABSECONDARY'">
                    <input :id="'viewed-'+recording.id" v-model="recording.viewed"
                           @change="toggleRecordingView(recording)"
                           type="checkbox" autocomplete="off" class="custom-control-input switch-input">
                    <label :for="'viewed-'+recording.id" class="custom-control-label d-block ml-0"></label>
                  </div>
                </td>
                <td>
                  <button v-if="recording.canDownload" @click="getDownloadLinkClick(recording)" class="recording-download-button button--text d-flex align-items-center">
                    <i class="isax isax-document-download"></i>
                    <span>
                      {{ $t("recordings.downloadsession") }}
                    </span>
                  </button>
                </td>
                <td v-if="['ROLE_ADMIN', 'ROLE_PRESENTER', 'ROLE_EVALUATOR'].some(i => user_roles.includes(i))">
                  <div class="item-list__item-controls justify-content-end" v-if="recording.targetSystem === 'COLLABSECONDARY'">
                    <b-dropdown right menu-class="button-list-icons small-icons"
                                variant=" icon-button session-row-options list-item-icon has-tooltip d-flex align-items-center"
                                toggle-class="text-decoration-none" no-caret>
                      <template :id="'recording-options-' + recording.id" #button-content>
                        <dots-horizontal-icon :size="24"/>
                        <b-tooltip :target="'recording-options-' + recording.id" triggers="hover">
                          {{ $t("recordings.options") }}
                        </b-tooltip>
                      </template>
                      <b-dropdown-item-btn v-if="recording.targetSystem === 'COLLABSECONDARY' && ['ROLE_ADMIN', 'ROLE_PRESENTER', 'ROLE_EVALUATOR'].some(i => user_roles.includes(i))" @click="dispatchShowReportEvent(recording.id)" link-class="button" v-b-toggle.sidebar-no-header="'sidebar-event-report-' + recording.id">
                        <span>{{ $t("sessions.seereports") }}</span>
                      </b-dropdown-item-btn>
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <RecordingVideoPlayer :player_url="player_url" :captions_url="player_captions_url" :chat="chat" :title="player_title" player_id="" :recording="current_recording"></RecordingVideoPlayer>
        </div>
      </div>
      <ReuseSessionSidebar
        @reuse="reuseClassroom">
      </ReuseSessionSidebar>
      <EditClassroomSidebar
        :groups="user_groups"
        @refresh="getUserGroupsClassrooms()">
      </EditClassroomSidebar>
      <EditClassroomSidebar
        id="sidebar-edit-reuse"
        :classroom="reuse_classroom"
        :groups="user_groups"
        @refresh="getUserGroupsClassrooms()">
      </EditClassroomSidebar>
      <vue-confirm-dialog class="pv-confirm"></vue-confirm-dialog>
    </main>
  </div>
</template>

<script>
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import DotsHorizontalIcon from 'vue-material-design-icons/DotsHorizontal.vue'
import CalendarBlankOutlineIcon from 'vue-material-design-icons/CalendarBlankOutline.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import PhoneOutgoingOutlineIcon from 'vue-material-design-icons/PhoneOutgoingOutline.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import CheckCircleOutlineIcon from 'vue-material-design-icons/CheckCircleOutline.vue'
import SyncIcon from 'vue-material-design-icons/Sync.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import PlayOutlineIcon from 'vue-material-design-icons/PlayOutline.vue'
import LoadingIcon from 'vue-material-design-icons/Loading.vue'
import PlayCircleIcon from 'vue-material-design-icons/PlayCircle.vue'
import PlayCircleOutlineIcon from 'vue-material-design-icons/PlayCircleOutline.vue'
import CloseIcon from 'vue-material-design-icons/Close.vue'
import TextBoxSearchOutlineIcon from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import jwtMixin from '../../mixins/jwtMixin'
import utilitiesMixin from '../../mixins/utilitiesMixin'
import RecordingVideoPlayer from '../Player/RecordingVideoPlayer'
import ReuseSessionSidebar from './SessionsModals/ReuseSessionSidebar'
import EditClassroomSidebar from './SessionsModals/EditClassroomSidebar'
import EventsReportSidebar from './SessionsModals/EventsReportSidebar'
import Sidebar from '../../components/Lti/Sidebar'

export default {
  name: 'Recordings',
  components: {Sidebar, RecordingVideoPlayer, DotsHorizontalCircleOutlineIcon, DotsHorizontalIcon, CalendarBlankOutlineIcon, LocationEnterIcon, PhoneOutgoingOutlineIcon, MagnifyIcon, CheckCircleOutlineIcon, SyncIcon, CloudDownloadOutlineIcon, PlayCircleIcon, PlayOutlineIcon, LoadingIcon, PlayCircleOutlineIcon, CloseIcon, TextBoxSearchOutlineIcon, EditClassroomSidebar, ReuseSessionSidebar, EventsReportSidebar},
  mixins: [jwtMixin, utilitiesMixin],
  created () {
    this.$i18n.locale = this.jwtLanguage()
    this.initUserClassroomsRecordings()
  },
  data () {
    return {
      loading: false,
      user_groups: [],
      user_roles: [],
      recordings: [],
      selected_filter: this.$i18n.t('recordings.recent'),
      search_show: false,
      filter_start_date: window.moment().subtract(2, 'months').format('YYYY-MM-DD'),
      filter_end_date: window.moment().endOf('day').format('YYYY-MM-DD'),
      filter_name: null,
      waiting_filter_name: false,
      player_url: null,
      player_title: null,
      player_captions_url: null,
      chat: null,
      reuse_classroom: null,
      current_recording: null
    }
  },
  watch: {
    filter_name: function (val) {
      let vueComponent = this
      if (!this.waiting_filter_name) {
        setTimeout(() => {
          vueComponent.getUserGroupsClassroomsRecordings()
          this.waiting_filter_name = false
        }, 1500)
      }
      this.waiting_filter_name = true
    }
  },
  computed: {
    has_visualization: function () {
      // la columna visualization solo aplica si existe alguna grabación descargadas
      return this.recordings != null && this.recordings.some((item) => item.targetSystem === 'COLLABSECONDARY')
    }
  },
  methods: {
    initUserClassroomsRecordings () {
      let vueComponent = this
      this.loading = true

      const licenceId = this.jwtConsumerId()
      const site = this.jwtContextSite()
      this.user_roles = this.jwtLoggedUserRoles()

      // CMM: Se recuperan los grupos para el usuario conectado. Los administradores tiene acceso a todos los grupos
      if (this.user_roles.indexOf('ROLE_ADMIN') !== -1) {
        window.axios.get('licences/' + licenceId + '/site/' + site + '/unirgroups').then((response) => {
          vueComponent.user_groups = response.data
          // CMM: Se recuperan las grabaciones para los grupos
          vueComponent.getUserGroupsClassroomsRecordings()
        })
      } else {
        window.axios.get('licences/' + licenceId + '/site/' + site + '/currentuser/unirgroups').then((response) => {
          vueComponent.user_groups = response.data
          // CMM: Se recuperan las grabaciones para los grupos
          vueComponent.getUserGroupsClassroomsRecordings()
        })
      }
    },
    getUserGroupsClassroomsRecordings () {
      let vueComponent = this
      if (!vueComponent.user_groups.length > 0) {
        this.loading = false
        return
      }
      let filterParams = new URLSearchParams()
      vueComponent.user_groups.forEach(function (ug) {
        filterParams.append('groups', ug.unirid)
      })
      filterParams.append('startTime', window.moment(this.filter_start_date).startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'))
      filterParams.append('endTime', window.moment(this.filter_end_date).endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'))
      // CMM: El filtro por nombre se aplica si hay algo seleccionado
      if (this.filter_name) {
        filterParams.append('name', this.filter_name)
      }
      window.axios.get('recordings/', {params: filterParams}).then((response) => {
        // CMM: Se efectúan las matrículas en los grupos y se recuperan las URLs de acceso
        vueComponent.recordings = response.data
        this.loading = false
      })
    },
    hideSearch () {
      this.search_show = false
      this.filter_name = null
      this.waiting_filter_name = false
    },
    showSearch () {
      this.search_show = true
    },
    recentRecordings () {
      let consumerCode = this.jwtConsumerCode()
      if (consumerCode != null && consumerCode === 'moodle') {
        window.document.querySelector('.body-content .full-width-content--small').classList.remove('interval-table-moodle')
      } else if (consumerCode != null && consumerCode === 'canvas') {
        window.document.querySelector('.body-content .full-width-content--small').classList.remove('interval-table-canvas')
      }
      this.selected_filter = this.$i18n.t('recordings.recent')
      this.filter_start_date = window.moment().subtract(2, 'months').format('YYYY-MM-DD')
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.getUserGroupsClassroomsRecordings()
    },
    recordingIntervals () {
    },
    getLaunchLinkClick (recording) {
      let vueComponent = this
      let validMinutes = 5
      if (!recording.loadingLaunchUrl && !recording.launchUrl) {
        this.$set(recording, 'loadingLaunchUrl', true)
        // CMM: Se recupera la URL de la grabación
        let urlParams = {
          targetSystem: recording.targetSystem,
          acInstanceId: recording.acInstance,
          validMinutes: validMinutes
        }
        window.axios.get('recordings/' + recording.id + '/url/', {params: urlParams}).then((response) => {
          vueComponent.$set(recording, 'loadingLaunchUrl', false)
          vueComponent.$set(recording, 'launchUrl', response.data.url)
          // CMM: A los 5 minutos el link pierde vigencia
          setTimeout(function () {
            vueComponent.$set(recording, 'launchUrl', '')
          }, validMinutes * 60000)
        })
      }
    },
    launchUrl (url, target, recording) {
      // CMM: Si es una grabación de Collaborate se abre el player en modal
      if (recording && recording.targetSystem === 'COLLABSECONDARY') {
        this.player_url = url
        this.player_title = recording.name
        this.player_captions_url = recording.captionsUrl
        this.chat = recording.chat
        this.current_recording = recording
        this.$bvModal.show('collaborate-recording-player-')
      } else {
        window.open(url, target)
      }
    },
    launchClickUrl (target, recording) {
      let vueComponent = this
      let validMinutes = 5
      if (!recording.loadingLaunchUrl && !recording.launchUrl) {
        this.$set(recording, 'loadingLaunchUrl', true)
        // CMM: Se recupera la URL de la grabación
        let urlParams = {
          targetSystem: recording.targetSystem,
          acInstanceId: recording.acInstance,
          validMinutes: validMinutes
        }
        window.axios.get('recordings/' + recording.id + '/url/', {params: urlParams}).then((response) => {
          vueComponent.$set(recording, 'loadingLaunchUrl', false)
          vueComponent.$set(recording, 'launchUrl', response.data.url)
          // CMM: A los 5 minutos el link pierde vigencia
          setTimeout(function () {
            vueComponent.$set(recording, 'launchUrl', '')
          }, validMinutes * 60000)
          vueComponent.launchUrl(recording.launchUrl, target, recording)
        })
      } else {
        vueComponent.launchUrl(recording.launchUrl, target, recording)
      }
    },
    getDownloadLinkClick (recording) {
      let vueComponent = this
      let urlParams = {
        targetSystem: recording.targetSystem,
        acInstanceId: recording.acInstance,
        disposition: 'download'
      }
      let target = '_self'
      if (recording.targetSystem === 'CONNECT') {
        target = '_blank'
      }
      window.axios.get('recordings/' + recording.id + '/url/', {params: urlParams}).then((response) => {
        vueComponent.launchUrl(response.data.url, target)
      })
    },
    reuseClassroom (classroom) {
      this.reuse_classroom = classroom
      // Se abre la edicón de la sesión reutilizada
      this.$root.$emit('bv::toggle::collapse', 'sidebar-edit-reuse')
      console.log(classroom)
    },
    dispatchShowReportEvent (recordingId) {
      window.EventBus.$emit('show-report', recordingId)
    },
    toggleRecordingView (recording) {
      // EdF: Se envía el nuevo estado de visualizado de la grabación si existe usuario en el token
      const userId = this.jwtLoggedUserId()

      let recordingUserParams = {
        recordingId: recording.id,
        userId: userId,
        viewed: recording.viewed
      }
      window.axios.patch('recordings/' + recording.id + '/user/' + userId, recordingUserParams).then((response) => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/Recordings.vue